import { useLocalisedLink } from '@parcel2go/npm-p2g-app';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { TenantSettingKeys } from '~/lib/consts/tenant-setting-keys';

const locale = 'locale';

const useTrackingLink = () => {
  const { configLink } = useLocalisedLink();
  const params = useParams();
  const generateTrackingPageUrl = useCallback(
    (ref: string) => {
      const link = configLink(TenantSettingKeys.Links.Tracking);
      if (link) {
        return link.endsWith('/') ? `${link}${ref}` : `${link}/${ref}`;
      }
      return params[locale] ? `${params[locale]}/tracking/${ref}` : `/tracking/${ref}`;
    },
    [params, configLink]
  );
  return { generateTrackingPageUrl } as const;
};

export default useTrackingLink;
